'use client'

import {
  EditShipperCompanyData,
  type IBasicUser,
  type ICompanyLiteData,
  useEditUserApi,
  useSession,
} from '@repo/sdk'

export const useCompanyApi = () => {
  const { createCompany, editCompany, editUserShipper } = useEditUserApi()
  const session = useSession()

  const updateCompany = async (data: EditShipperCompanyData, companyId: number) => {
    await editCompany(data, companyId)
  }

  const createNewCompany = async (data: ICompanyLiteData, user: Partial<IBasicUser>) => {
    try {
      const companyResponse = await createCompany(data)
      if (user?.email && user?.id) {
        await editUserShipper({
          company_id: companyResponse.id,
          email: user?.email,
          firstName: user.name,
          id: user?.id,
          phone: user.phone,
        })
        await session.update({
          user: {
            company: companyResponse,
          },
        })
      } else {
        throw new Error('Invalid user data')
      }
    } catch (error) {
      throw new Error('Something went wrong, please contact our team')
    }
  }

  return { createNewCompany, updateCompany }
}
